import { Component, OnInit, Renderer2, OnDestroy, AfterViewInit, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Validators } from "@angular/forms";
import { AuthService } from "../../service/auth-service/auth.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { sweetAlert } from "../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { environment } from "src/environments/environment";
import { AssigTripsService } from "../assigned-trips/assigntrips-service/assigntrips-service";


@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"],
})
export class SignInComponent implements OnInit, OnDestroy , AfterViewInit {
  success: boolean;
  passwordToggleFlag = true;
  signInForm: FormGroup;
  submitted = false;
  isAdmin = false;
  isCompany = true;
  isShowToggler = false;
  snowCanvas: HTMLCanvasElement;
  snowInterval: any;
  snowTimeout: any;

  constructor(
    private renderer: Renderer2,
    private fb: FormBuilder,
    private assignTripService: AssigTripsService,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router,
    private renderere: Renderer2,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    window.addEventListener("keyup", this.initializeTimer);
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });

    // if (!environment.production) {
    //   this.signInForm.patchValue({
    //     email: "medfastcab@yamsol.com",
    //     password: "123456"
    //   });
    // }
    // this.applyFirworks();
  }

  randomInRange(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  initializeTimer = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isShowToggler = !this.isShowToggler;
      if (this.isShowToggler) {
        this.isAdmin = true;
        this.isCompany = false;
      } else {
        this.isCompany = true;
        this.isAdmin = false;
      }
    }
  };

  get form() {
    return this.signInForm.controls;
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  onSignIn() {

    this.submitted = true;
    if (this.signInForm.invalid) {
      return;
    }

    let role;

    if (this.isAdmin) {
      role = 'admin';

    } else {
      if (this.isCompany) {
        role = 'company';
      } else {
        role = 'staff';
      }

    }



    this.authService
      .login(this.signInForm.value.email, this.signInForm.value.password, role)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
          this.authService.setToken(data.token);
          this.sharedDataService.saveUser(data.user);
          this.socket.connectSocket();
          this.getNemtCodes();
          // this.router.navigateByUrl('/');
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  getNemtCodes() {
    this.assignTripService
      .getNemtCodes()
      .subscribe((data: any) => {
        if (data && data.length) {
          this.sharedDataService.saveNemtCodes(data);
        }
        this.router.navigateByUrl('/');
      }, err => {
        this.router.navigateByUrl('/');
      });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    this.renderere.appendChild(document.body, script);
    return script;
  }

  changeAdminRole() {
    this.isAdmin = !this.isAdmin;
    this.isCompany = true;
  }
  ngOnDestroy(): void {
    window.removeEventListener("keyup", this.initializeTimer);
    // this.fireworks.waitStop(true);
  }


  ngAfterViewInit(){

  this.applySnow();

  }

applySnow() {
  this.snowCanvas = document.createElement('canvas');
  this.snowCanvas.style.position = 'fixed';
  this.snowCanvas.style.top = '0';
  this.snowCanvas.style.left = '0';
  this.snowCanvas.style.width = '100%';
  this.snowCanvas.style.height = '100%';
  this.snowCanvas.style.pointerEvents = 'none';
  this.snowCanvas.style.zIndex = '9999';

  document.body.appendChild(this.snowCanvas);

  const ctx = this.snowCanvas.getContext('2d');
  this.snowCanvas.width = window.innerWidth;
  this.snowCanvas.height = window.innerHeight;

  const flakes = [];
  const flakeCount = 200;

  for (let i = 0; i < flakeCount; i++) {
    flakes.push({
      x: Math.random() * this.snowCanvas.width,
      y: Math.random() * this.snowCanvas.height,
      r: Math.random() * 4 + 1,
      d: Math.random() * flakeCount
    });
  }

  let angle = 0;

  const drawSnow = () => {
    ctx.clearRect(0, 0, this.snowCanvas.width, this.snowCanvas.height);
    ctx.fillStyle = 'white';
    ctx.beginPath();

    for (const f of flakes) {
      ctx.moveTo(f.x, f.y);
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
    }

    ctx.fill();
    moveSnow();
  };

  const moveSnow = () => {
    angle += 0.01;
    for (let i = 0; i < flakes.length; i++) {
      const f = flakes[i];
      f.y += Math.cos(angle + f.d) + 1 + f.r / 2;
      f.x += Math.sin(angle) * 0.5;

      if (f.y > this.snowCanvas.height) {
        flakes[i] = {
          x: Math.random() * this.snowCanvas.width,
          y: 0,
          r: f.r,
          d: f.d
        };
      }
    }
  };

  // Start animation
  this.snowInterval = setInterval(drawSnow, 25);

  // ⏱ Stop after 30 seconds
  this.snowTimeout = setTimeout(() => {
    this.stopSnow();
  }, 30000);
}

stopSnow() {
  if (this.snowInterval) {
    clearInterval(this.snowInterval);
    this.snowInterval = null;
  }

  if (this.snowCanvas) {
    document.body.removeChild(this.snowCanvas);
    this.snowCanvas = null;
  }
}



}
